import React from 'react';
import Well from '$components/ProductDashboard/Well';
import MiniRefer from '$components/ProductDashboard/MiniRefer';
import MiniSearch from '$components/ProductDashboard/MiniSearch';
import StudyReportRefer from '$components/ProductDashboard/StudyReportRefer';
import styles from './styles.scss';

const DashboardExtra = (props) => {
  const { currentUser, product } = props;

  return (
    <div className={styles.background}>
      <Well>
        <div className={styles.layout}>
          <div className={styles.item}>
            <MiniSearch product={product} />
          </div>
          <div className={styles.item}>
            <MiniRefer currentUser={currentUser} product={product} />
          </div>
          {/* <div className={styles.item}>&nbsp;</div>
          <div className={styles.item}>
            <StudyReportRefer product={product} />
          </div> */}
        </div>
      </Well>
    </div>
  );
};

export default DashboardExtra;
